/**
 * TrialExtensionTopBarAction
 * Persistent top bar entry point to the trial extension offer, visible on every
 * page and breakpoint while the offer is available (icon-only on small screens).
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { useTrialExtension } from "../../../hooks/useTrialExtension";
import { TRIAL_EXTENSION_TOPBAR_ACTION_ID } from "../../../lib/trialExtension";
import { Button } from "../UIElements/Button";
import { Icon } from "../UIElements/Icon";

const TrialExtensionTopBarAction = () => {
  const { t } = useTranslation(["billing"]);
  const { available, days, openBooking } = useTrialExtension();

  if (!available) return null;

  return (
    <Button
      type="button"
      onClick={() => openBooking("topbar")}
      variant="ghost"
      size={null}
      className="ordering-shell__control text-info flex min-h-8 items-center gap-1 bg-[var(--info-bg)] px-2 py-1.5 hover:brightness-95 sm:gap-2"
      id={TRIAL_EXTENSION_TOPBAR_ACTION_ID}
      // Starts with the visible text (WCAG 2.5.3); the rest names the offer.
      aria-label={t("trialExtension.topBarActionLabel", { days })}
      data-testid="trial-extension-topbar-action"
    >
      <Icon name="Calendar" className="text-info h-4 w-4 flex-shrink-0" />
      <span className="hidden text-[13px] font-medium sm:inline">
        {t("trialExtension.topBarAction")}
      </span>
    </Button>
  );
};

export default TrialExtensionTopBarAction;
